import api from '../api/api';

// Meldet Client-Fehler (inkl. Rauswürfe/Logouts) an das In-App-Fehler-Log. Strikt best-effort:
// darf niemals werfen und ist gedrosselt, damit ein Fehler-Burst die DB nicht flutet.

let recent: number[] = [];
const MAX_PER_MINUTE = 12;

export function reportClientError(
  context: string,
  err: unknown,
  extra?: { statusCode?: number; path?: string; level?: 'error' | 'warn' }
): void {
  try {
    // Nur eingeloggt melden (Endpoint braucht auth).
    if (!localStorage.getItem('token')) return;

    const now = Date.now();
    recent = recent.filter(t => now - t < 60000);
    if (recent.length >= MAX_PER_MINUTE) return;
    recent.push(now);

    const anyErr = err as any;
    const message = anyErr?.message ?? (typeof err === 'string' ? err : JSON.stringify(err)?.slice(0, 500)) ?? 'unknown';
    const stack = anyErr?.stack;
    const statusCode = extra?.statusCode ?? anyErr?.response?.status;
    const path = extra?.path ?? anyErr?.config?.url;

    // Diagnose-Zusatz: App-Version + Bildschirm/Viewport (hilft bei „nur am Handy"-Fällen).
    const ver = (window as unknown as { __APP_VERSION__?: string }).__APP_VERSION__ || '?';
    const meta = `App ${ver} · ${window.screen.width}×${window.screen.height} @${window.devicePixelRatio || 1}x · Viewport ${window.innerWidth}×${window.innerHeight}`;

    // .catch verhindert, dass ein fehlgeschlagener Report selbst eine unhandledrejection auslöst.
    api.post('/error-logs/client', {
      context: String(context).slice(0, 191),
      message: String(message).slice(0, 4000),
      stack: stack ? String(stack).slice(0, 6000) : undefined,
      statusCode: typeof statusCode === 'number' ? statusCode : undefined,
      path: path ? String(path).slice(0, 255) : undefined,
      url: (window.location.pathname + window.location.search).slice(0, 255),
      meta: meta.slice(0, 255),
      level: extra?.level || 'error',
    }).catch(() => { /* ignore */ });
  } catch { /* ignore */ }
}

// Globale Handler einmalig registrieren (window.onerror + unhandledrejection).
let installed = false;
export function installGlobalErrorReporting(): void {
  if (installed) return;
  installed = true;
  window.addEventListener('error', (e) => {
    reportClientError('window.onerror', e.error || e.message);
  });
  window.addEventListener('unhandledrejection', (e) => {
    // API-Fehler auf den Report-Endpoint selbst nicht rekursiv melden.
    const url = (e.reason as any)?.config?.url || '';
    if (String(url).includes('/error-logs/client')) return;
    reportClientError('unhandledrejection', e.reason);
  });
}
